"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var styled_system_1 = require("styled-system");

var theme_get_1 = require("@styled-system/theme-get");

var dividerBorderColor = styled_system_1.style({
  key: 'colors.border',
  prop: 'color',
  cssProperty: 'background-color'
});
exports.Divider = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  width: auto;\n  text-align: center;\n  position: relative;\n  height: ", ";\n  ", ";\n\n  &::before {\n    position: absolute;\n    content: '';\n    height: 1px;\n    left: 0;\n    right: 0;\n    top: 50%;\n    ", ";\n  }\n"], ["\n  display: block;\n  width: auto;\n  text-align: center;\n  position: relative;\n  height: ", ";\n  ", ";\n\n  &::before {\n    position: absolute;\n    content: '';\n    height: 1px;\n    left: 0;\n    right: 0;\n    top: 50%;\n    ", ";\n  }\n"])), function (props) {
  return Boolean(props.children) ? 'auto' : '1px';
}, styled_system_1.space, dividerBorderColor);
exports.Divider.defaultProps = {
  color: 'light'
};
var labelColor = styled_system_1.style({
  key: 'colors.text',
  prop: 'color',
  cssProperty: 'color'
});
var DividerLabel = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  z-index: 10;\n  position: relative;\n  background-color: white;\n  padding-top: 0;\n  padding-bottom: 0;\n  font-size: ", ";\n  line-height: ", ";\n  ", ";\n  ", ";\n"], ["\n  z-index: 10;\n  position: relative;\n  background-color: white;\n  padding-top: 0;\n  padding-bottom: 0;\n  font-size: ", ";\n  line-height: ", ";\n  ", ";\n  ", ";\n"])), theme_get_1.themeGet('fontSizes.body.sm'), theme_get_1.themeGet('lineHeights.body.sm'), styled_system_1.space, labelColor);
DividerLabel.defaultProps = {
  color: 'default',
  px: 'sm'
};
exports.Divider.Label = DividerLabel;
var templateObject_1, templateObject_2;